import { render, staticRenderFns } from "./ShowReport.vue?vue&type=template&id=1345adbe&"
import script from "./ShowReport.vue?vue&type=script&lang=js&"
export * from "./ShowReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports